import Table from "../Table";
import {useState,useEffect,useRef} from "react";
import {Ajax} from "../../Service/ajax";
import {ClipLoader} from "react-spinners";
import {useNavigate} from "react-router-dom";
import {plans, security} from "../../env/Environment";
import Swal from "sweetalert2";
export default function OptionsForm({title, nb}){
    const application=JSON.parse(sessionStorage.getItem("application"));
    const popoverRef = useRef(null);
    const [suggestions, setSuggestions] = useState([]);
    const [filteredSuggestions, setFilteredSuggestions] = useState([]);
    const [showPopover, setShowPopover] = useState(false);
    const [optionsList, setOptionsList]=useState([]);
    const [tagValue, setTagValue] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const session = sessionStorage.getItem("session");
    const trf = sessionStorage.getItem("trf");
    const [enable, setEnable] = useState(true);

    const handleClickOutside = (event) => {
        if (popoverRef.current && !popoverRef.current.contains(event.target)) {
            setShowPopover(false);
        }
    };

    const handleAbort = () =>{
        setOptionsList([]);
    }

    useEffect(() => {
        const fetchData = async (trf_id) => {
            try {
                let isActive ;
                isActive = JSON.parse(trf).status === "ACTIVE";
                const {data} = await Ajax.getRequest(`/exposed/v1/sub/options/retrieve`);
                let suggestion =data.object.content;
                setSuggestions(suggestion)
            } catch (error) {
                let errorCode;
                if (error.response) {
                    errorCode = error.response.status;
                } else {
                    errorCode = 500;
                }
                navigate('/error-page', { state: { errorCode } });
            }
        };
        if(session && trf){
            fetchData(JSON.parse(trf).id);
        }else{
            navigate("/")
        }

        window.addEventListener('click', handleClickOutside);

        return () => {
            window.removeEventListener('click', handleClickOutside);
        };

    }, [navigate,session]);

    const handleAddClick = () => {
        const typeAct = document.getElementById('inputGroupSelectOp').value;
        const newOption = {
            title: tagValue,
            dataType: typeAct,
        };
        if(newOption.title !== "" && newOption.dataType !==""){
            if (optionsList.length === 1) {
                if (optionsList[0].title === "N/D") {
                    setOptionsList([newOption]);
                } else {
                    const isNotRepeated = !optionsList.some(option =>
                        option.title === newOption.title && option.dataType === newOption.dataType
                    );
                    if (isNotRepeated) {
                        setOptionsList([...optionsList, newOption]);
                    }
                }
            } else {
                const isNotRepeated = !optionsList.some(option =>
                    option.title === newOption.title && option.dataType === newOption.dataType
                );
                if (isNotRepeated) {
                    setOptionsList([...optionsList, newOption]);
                }
            }
        }
        setTagValue('');
        document.getElementById('inputGroupSelectOp').value = 'TEXTE';
    };

    const handleOnClick = async () => {
        let trf_id = JSON.parse(trf).id;
        if(!session){
            navigate("/");
        }else{
            if(JSON.parse(trf).status === "EXPIRED"){
                Swal.fire({
                    title: 'Information!',
                    text: "Votre abonnement a deja expirer, voudriez-vous vous reabonner ou changer de plan d'abonnement pour plus?",
                    icon: 'info',
                    showCancelButton: true,
                    confirmButtonColor:'#debf66',
                    focusConfirm:true,
                    confirmButtonText: 'Oui',
                    cancelButtonText:'Non',
                    customClass:{
                        container: 'sweetAlert-custom-class'
                    }
                }).then(async (result)=>{
                    if(result.isConfirmed){
                        navigate('/particulier')
                    }
                });
            }else{
                const sendData = optionsList.map(item => {
                    return {
                        'tag': item.title,
                        "dataType": item.dataType,
                    };
                });
                try {
                    setLoading(true);
                    const {data} = await Ajax.putRequest(`/api/v1/sub/application/${application.id}/options/add`, sendData);
                    if (data.error) {
                        sessionStorage.setItem("error", data.error);
                        sessionStorage.setItem("message", data.message);
                        window.location.reload();
                    } else{
                        sessionStorage.setItem("success","Nouvelle option ajoutée avec succès");
                        window.location.reload();
                    }
                } catch (error) {
                    Swal.fire({
                        title: 'Error!',
                        text:`Oups! Une erreur s'est produite, veuillez reesayer plus tard.`,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        customClass: {
                            popup: 'custom-popup',
                            confirmButton: 'custom-button'
                        },
                        timer: 5000
                    });
                }finally {
                    setLoading(false)
                }
            }
        }
    };

    const handleChangeTag = (e) => {
        const value = e.target.value;
        setTagValue(value);


        const filtered = suggestions.filter(suggestion =>
            suggestion.title.toLowerCase().includes(value.toLowerCase())
        ).map(item => `${item.title} : ${item.type}`);


        setFilteredSuggestions(filtered);


        setShowPopover(!!value);
    };


    const handleSelectSuggestion = (suggestion) => {
        const [title, type] = suggestion.split(':').map(item => item.trim());
        const newOption = {
            title: title,
            dataType: type,
        };
        if (optionsList.length === 1) {
            if (optionsList[0].title === "N/D") {
                setOptionsList([newOption]);
            } else {
                const isNotRepeated = !optionsList.some(option =>
                    option.title === newOption.title && option.dataType === newOption.dataType
                );
                if (isNotRepeated) {
                    setOptionsList([...optionsList, newOption]);
                }
            }
        } else {
            const isNotRepeated = !optionsList.some(option =>
                option.title === newOption.title && option.dataType === newOption.dataType
            );
            if (isNotRepeated) {
                setOptionsList([...optionsList, newOption]);
            }
        }
        setTagValue('');
        document.getElementById('inputGroupSelectOp').value = 'TEXTE';
        setFilteredSuggestions([]);
        setShowPopover(false);
    };

    return(
        <div className="modal-content" >
            <div className="modal-header">
                <h5 className="modal-title" id="modalFullTitle">{title}</h5>
                <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                ></button>
            </div>
            <div className="modal-body">
                <div className="col-md-12">
                    <div className="row">
                        <div className="col-md-3">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card mb-4">
                                        <h5 className="card-header">Ajouter une options</h5>
                                        <div className="card-body demo-vertical-spacing demo-only-element">
                                            <div className="input-group">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Tag de option"
                                                    aria-label="Tag"
                                                    value={tagValue}
                                                    onChange={handleChangeTag}
                                                />
                                                {showPopover && (
                                                    <div
                                                        className="popover" ref={popoverRef}
                                                        style={{
                                                            position: 'absolute',
                                                            top: '100%',
                                                            left: 0,
                                                            zIndex: 1060,
                                                            display: 'block',
                                                            width:'260px',
                                                            maxHeight: '200px',
                                                            overflowY: 'auto',
                                                        }}
                                                    >
                                                        <div className="arrow"></div>
                                                        <div className="popover-body">
                                                            <ul className="list-group">
                                                                {filteredSuggestions.map((suggestion, index) => (
                                                                    <li
                                                                        key={index}
                                                                        className="list-group-item"
                                                                        onClick={() => handleSelectSuggestion(suggestion)}
                                                                    >
                                                                        {suggestion}
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="input-group">
                                                <label className="input-group-text col-3"
                                                       htmlFor="inputGroupSelectOp">Type</label>
                                                <select className="form-select" id="inputGroupSelectOp">
                                                    <option selected value="TEXT">TEXTE</option>
                                                    <option value="DATE">DATE</option>
                                                    <option value="NUMBER">NOMBRE</option>
                                                </select>
                                            </div>
                                            <button type="button" className={enable ? "btn btn-netikash" : "btn btn-netikash disabled"} onClick={handleAddClick}>Ajouter</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-9">
                            <div className="card mb-4">
                                <Table title={"Options"} content={optionsList} type={"optionsMini"} setResource={setOptionsList}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button type="button" className={`btn btn-outline-netikash ${loading ? 'disabled' : ''}`} onClick={handleAbort} data-bs-dismiss="modal">
                    Fermer
                </button>
                <button
                    type="button"
                    className={`btn btn-netikash ${loading || !enable ? 'disabled' : ''}`}
                    onClick={handleOnClick}
                >
                    {loading ? (
                        <ClipLoader color="#36d7b7" loading size={15}/>
                    ) : (
                        'Enregister'
                    )}
                </button>
            </div>
        </div>
    );
}
